module.exports = __webpack_public_path__ + "static/media/dot_circle.7eb27f57.png";